import { registerPlugin } from '@capacitor/core'
import type { PluginListenerHandle } from '@capacitor/core'

// Optional: define a minimal interface for the Braze bridge if you know methods
export interface BrazeBridgePluginApi {
  setUserId(options: { userId: string }): Promise<void>
  logout(): Promise<void>
  checkPushPermission(): Promise<{ permission: string }>
  requestPushPermission(): Promise<{ permission: string }>
  openAppSettings(): Promise<void>
  addListener?(eventName: string, listenerFunc: (...args: any[]) => void): Promise<PluginListenerHandle>
}

let brazeBridgeInstance: BrazeBridgePluginApi | null = null

export default defineNuxtPlugin({
  name: 'braze-bridge',
  setup () {
    // Only register once on client side
    if (import.meta.client && !brazeBridgeInstance) {
      brazeBridgeInstance = registerPlugin<BrazeBridgePluginApi>('BrazeBridgePlugin')
    }

    return {
      provide: {
        brazeBridge: brazeBridgeInstance
      }
    }
  }
})
